module.exports = __webpack_public_path__ + "f8581dde130e2ca7e31df6307d367626.png";